import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { FullComponent } from "./layouts/full/full.component";
import { BlankComponent } from "./layouts/blank/blank.component";
import { AuthGuard } from "./auth.guard";
import { BrowserSupportComponent } from "./views/common/dialogs/browser-support/browser-support.component";
import { MaintenanceComponent } from "./views/common/maintenance/maintenance.component";
import { MaintenanceGuard } from "./maintenance.guard";

export const Approutes: Routes = [
  {
    path: "",
    canActivate: [AuthGuard],
    component: FullComponent,
    children: [
      // { path: "", redirectTo: "/Web", pathMatch: "full" }, // Only for maintenance mode
      { path: "", redirectTo: "/WebPanel", pathMatch: "full" },
      // {
      //   path: "dashboard",
      //   loadChildren: () =>
      //     import("./dashboards/dashboard.module").then(
      //       (m) => m.DashboardModule
      //     ),
      // },
      {
        path: "AdminPanel",
        loadChildren: () =>
          import("../app/views/AdminPanel/admin-panel.module").then(
            (m) => m.AdminPanelModule
          ),
      },
      // {
      //   path: 'component',
      //   loadChildren: () => import('./component/component.module').then(m => m.ComponentsModule)
      // },
      // { path: 'cards', loadChildren: () => import('./cards/cards.module').then(m => m.CardsModule) },
      // { path: 'icons', loadChildren: () => import('./icons/icons.module').then(m => m.IconsModule) },
      // { path: 'forms', loadChildren: () => import('./form/forms.module').then(m => m.FormModule) },
      // {
      //   path: "tables",
      //   loadChildren: () =>
      //     import("./table/tables.module").then((m) => m.TablesModule),
      // },
      // {
      //   path: "charts",
      //   loadChildren: () =>
      //     import("./charts/charts.module").then((m) => m.ChartModule),
      // },
      // {
      //   path: 'widgets',
      //   loadChildren: () => import('./widgets/widgets.module').then(m => m.WidgetsModule)
      // },
      // { path: 'ecom', loadChildren: () => import('./ecommerce/ecom.module').then(m => m.EcomModule) },
      // {
      //   path: 'timeline',
      //   loadChildren: () => import('./timeline/timeline.module').then(m => m.TimelineModule)
      // },
      // {
      //   path: 'extra-component',
      //   loadChildren:
      //     () => import('./extra-component/extra-component.module').then(m => m.ExtraComponentModule)
      // },
      // { path: 'apps', loadChildren: () => import('./apps/apps.module').then(m => m.AppsModule) },
      // {
      //   path: 'apps/email',
      //   loadChildren: () => import('./apps/email/mail.module').then(m => m.MailModule)
      // },
      // { path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule) },
      // {
      //   path: 'sample-pages',
      //   loadChildren: () => import('./sample-pages/sample-pages.module').then(m => m.SamplePagesModule)
      // },
    ],
  },
  {
    path: "",
    component: BlankComponent,
    children: [
      {
        path: "authentication",
        loadChildren: () =>
          import("./authentication/authentication.module").then(
            (m) => m.AuthenticationModule
          ),
      },
      {
        path: "WebPanel",
        loadChildren: () =>
          import("./views/WebPanel/web-panel.module").then(
            (m) => m.WebPanelModule
          ),
      },
      {
        path: "Web",
        canActivate: [MaintenanceGuard],
        loadChildren: () =>
          import("./views/WebPanel/web-panel.module").then(
            (m) => m.WebPanelModule
          ),
      },
      {
        path: "browser-support",
        component: BrowserSupportComponent,
      },
      {
        path: "maintenance",
        component: MaintenanceComponent,
      }
    ],
  },
  {
    path: "**",
    redirectTo: "/authentication/404",
  },
];
